// removed by extract-text-webpack-plugin
module.exports = {"optionTypeSwitcher":"_11nr-Kz4_vdJlbIVxgN74f","optionTypeButton":"_1-CNdEAwlcI9Y1yOvq-0Ks","activeButton":"_2X7Kpo5gv_SyDhc3y9Fkek","separator":"_1yF_eBKNjzHt8uuO_QzEED"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Company/OptionTypeSwitcher/OptionTypeSwitcher.scss
// module id = 1586
// module chunks = 0